<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            {{t('quick-scan-history')}}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{t('ASM')}}
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('scan-history')}}
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('quick-scan-history')}}
            </li>
        </ol>
    </div>
    @if (isLoadingResults || isRateLimitReached) {
    <div class="loading-shade">
        @if (isLoadingResults) {
        <mat-spinner></mat-spinner>
        }
        @if (isRateLimitReached) {
        <div class="rate-limit-reached">
            ALTAIR rate limit has been reached. It will be reset in one minute.
        </div>
        }
    </div>
    }
    <!-- Scans -->
    <mat-card class="altair-card companies-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-header>
            <mat-card-title>
                <form class="search-box position-relative">
                    <i class="material-symbols-outlined">
                        search
                    </i>
                    <input matInput class="input-search d-block w-100 border-none outline-0"
                        placeholder="{{t('search')}} {{t('domain')}}..." (keyup)="applyFilter($event)"
                        (keydown.enter)="onKeydown($event)" #input>
                </form>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="companies-table">
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSource" matSort matSortActive="domainName" matSortDisableClear
                        matSortDirection="asc">

                        <!-- Domain Name Column -->
                        <ng-container matColumnDef="domainName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('domain')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.domain.name}}
                            </td>
                        </ng-container>

                        <!-- Summary Column -->
                        <ng-container matColumnDef="summary">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('summary')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <span class="badge badge-pills bg-info mt-1" data-toggle="tooltip" data-placement="top" title="{{t('subdomains')}}">{{row.subdomain_count}}</span>
                                <span class="badge badge-pills bg-warning mt-1" data-toggle="tooltip" data-placement="top" title="{{t('endpoints')}}">{{row.endpoint_count}}</span>
                                <span class="badge badge-pills bg-danger mt-1" data-toggle="tooltip" data-placement="top" title="{{t('vulnerabilities')}}">{{row.vulnerability_count}}</span>
                            </td>
                        </ng-container>

                        <!-- Scan Engine Used Column -->
                        <ng-container matColumnDef="scanEngineUsed">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('scanEngineUsed')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <span class="badge text-soft-primary">{{t(row.scan_type.engine_name)}}</span>
                            </td>
                        </ng-container>

                        <!-- Last Scan Column -->
                        <ng-container matColumnDef="lastScan">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('lastScan')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <span data-toggle="tooltip" data-placement="top" title="{{ formatDateHumanized(row.start_scan_date) }}">{{ row.start_scan_date | date:'medium' }}</span>
                            </td>
                        </ng-container>

                        <!-- Initiated By Column -->
                        <ng-container matColumnDef="initiatedBy">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('initiated-by')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                @if(row.initiated_by) {
                                <span class="badge text-soft-secondary">{{row.initiated_by.username}}</span>
                                }
                            </td>
                        </ng-container>

                        <!-- Status Column -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('status')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                            @if (row.scan_status == -1) {
                                <span class="badge text-soft-warning" data-toggle="tooltip" data-placement="top" title="{{t('waiting-to-complete')}}">
                                    <mat-spinner></mat-spinner> {{t('pending')}}
                                </span>
                            }
                            @else if (row.scan_status == 0) {
                                <span class="badge text-soft-danger">{{t('failed')}}</span>
                                @if (row.error_message) {
                                <br><p class="text-danger">{{t('scan-failed-due-to')}}: {{row.error_message}}</p>
                                }
                            }
                            @else if (row.scan_status == 1) {
                                <span class="badge text-soft-info">{{t('in-progress')}}</span>
                            }
                            @else if (row.scan_status == 2) {
                                <span class="badge text-soft-success">{{t('successful')}}</span>
                            }
                            @else if (row.scan_status == 3) {
                                <span class="badge text-soft-danger">{{t('aborted')}}</span>
                                @if(row.aborted_by) {
                                <br>
                                <small class="text-muted">{{t('aborted-by')}}: {{row.aborted_by.username}}</small>
                                }
                            }
                            @else {
                                <span class="badge text-soft-danger">{{t('unknown')}}</span>
                            }
                            </td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('action')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div class="action-info">
                                    <a mat-button routerLink="/asmview/scan-detail/{{row.id}}"
                                        matTooltip="{{t('view')}} {{t('results')}}" matTooltipPosition="above">
                                        <i class="material-symbols-outlined">
                                            visibility
                                        </i>
                                    </a>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{t('no-data-matching')}} "{{input.value}}"</td>
                        </tr>

                    </table>
                </div>
                <mat-paginator [length]="totalItems" [pageSizeOptions]="pageSizes" showFirstLastButtons></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</ng-container>
